import { get, set } from 'idb-keyval';
import { cookieBannerFunct } from './cookiebanner';

function refreshMobileHeighMenu(){
	const head = document.querySelector('.ocw-top-bar');
	const menuCont = document.querySelector('.menu-cont');
	const bounds = head.getBoundingClientRect();
	
	if(menuCont){
		menuCont.style.setProperty('--dialog-top', `${bounds.bottom + 1}px`);
		menuCont.style.setProperty('--dialog-height', `${(window.innerHeight * 1.3) - (bounds.bottom + 1)}px`);
	}
}

function getOS() {
	const { userAgent } = window.navigator;
	const platform = window.navigator?.userAgentData?.platform || window.navigator.platform;
	const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	let os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'Mac';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (/Linux/.test(platform)) {
		os = 'Linux';
	}

	return os;
}

function hideElementsWhenActive(){
	if(document.querySelector('.ocw-top-bar').classList.contains("is-active")){
		document.querySelector('.cookiebanner').style.display = `none`;
    	if(document.querySelector('.five9.chat-box')){
      		document.querySelector('.five9.chat-box').style.display = `none`;
    	}
		if(document.querySelector('.location-button')){
			document.querySelector('.location-button').style.display = `none`;
		}

	}
	else{
		if(document.querySelector('.five9.chat-box')){
			document.querySelector('.five9.chat-box').style.display = `block`;
		}
		if(document.querySelector('.location-button')){
			document.querySelector('.location-button').style.display = `block`;
		}
		cookieBannerFunct();
	}

}

export function navmenu() {
	/* ============================================================
	   Add Accessibility Attributes
	============================================================ */
    
	// Add aria-label to logo link
	const logoLink = document.querySelector('.navbar-container .logo a');
	if (logoLink && !logoLink.getAttribute('aria-label')) {
		logoLink.setAttribute('aria-label', 'Oportun Home - Return to homepage');
	}

	// Ensure hidden submenus are not in tab order on initial load
	const hiddenSubmenus = document.querySelectorAll('.sub-menu-container[aria-hidden="true"]');
	hiddenSubmenus.forEach((submenu) => {
		const links = submenu.querySelectorAll('a');
		links.forEach((link) => {
			link.setAttribute('tabindex', '-1');
		});
	});

	/* ============================================================
	   Utility and state helpers
	============================================================ */
	const navbarMenu = document.querySelector(".nav");
	const burgerMenu = document.querySelector(".hamburger");
	const menuContainer = document.querySelector('.menu-cont');

	const isMobile = () => window.innerWidth <= 1070;

	let position = { x: 0, y: 0 };

	// Manage tabbability inside submenus
	const setSubmenuFocusability = (submenuContainer, enable) => {
		if (!submenuContainer) return;
		const links = submenuContainer.querySelectorAll("a");
		links.forEach((link) => {
			if (enable) {
				link.removeAttribute("tabindex");
			} else {
				link.setAttribute("tabindex", "-1");
			}
		});
	};

	const closeAllSubmenus = () => {
		document.querySelectorAll(".menu-item-has-children").forEach((item) => {
			const submenu = item.querySelector(".sub-menu-container");
			const trigger = item.querySelector("a");

			if (submenu) {
				submenu.setAttribute("aria-hidden", "true");
				setSubmenuFocusability(submenu, false);
			}
			if (trigger) {
				trigger.setAttribute("aria-expanded", "false");
			}
			item.classList.remove("dropdown-show");
		});
	};


	/* ============================================================
	   1. Banner dismissal logic
	============================================================ */
	// Use event delegation to handle banner close button (works with dynamic elements)
	document.addEventListener('click', (e) => {
		if (e.target.closest('.banner button.close')) {
			document.querySelector('.banner')?.remove();
			refreshMobileHeighMenu();
			set('prefs-hide-banner', JSON.stringify({ show: 'banner', time: Date.now() }));
		}
	});

	// Set initial menu top if no banner exists
	if (!document.querySelector('.banner') && menuContainer) {
		menuContainer.style.setProperty('--dialog-top', `auto`);
	}


	/* ============================================================
	   2. OS detection and "Get App" section 
	============================================================ */
	const os = getOS();
	const getAppMsg = (document.documentElement.lang === 'en-US' ? 'Get app' : 'Obtén el app');
	const downloadClassName = (os === 'Android' || os === 'iOS' ? os : 'other').toLowerCase();
	const getAppContent = document.querySelector('.download.appstore');

	if (getAppContent) {
		getAppContent.classList.add(downloadClassName);

		// Create elements safely using DOM APIs
		const span = document.createElement('span');
		const link = document.createElement('a');
		link.href = 'https://app.oportun.com/download';
		link.target = '_blank';
		link.setAttribute('data-event_tracking', 'button click');
		link.setAttribute('data-event_tracking_label', 'Get app');
		link.setAttribute('data-event_tracking_section', 'Header');

		if (downloadClassName === "android") {
			const graphic = document.createElement('oportun-graphic');
			graphic.setAttribute('name', 'playstore-logo-mark');
			link.appendChild(graphic);
			link.appendChild(document.createTextNode(getAppMsg));
		} else if (downloadClassName === "ios") {
			const graphic = document.createElement('oportun-graphic');
			graphic.setAttribute('name', 'appstore-logo');
			link.appendChild(graphic);
			link.appendChild(document.createTextNode(getAppMsg));
		} else {
			link.textContent = getAppMsg;
		}

		span.appendChild(link);
		getAppContent.innerHTML = '';
		getAppContent.appendChild(span);
	}


	/* ============================================================
	   3. BURGER MENU (mobile)
	============================================================ */
	if (burgerMenu) {
		burgerMenu.addEventListener("click", () => {
			if (navbarMenu) navbarMenu.classList.toggle("is-active");
			burgerMenu.classList.toggle("is-active");
			menuContainer.classList.toggle("is-active");

			// Toggle aria-expanded for accessibility (WCAG disclosure button pattern)
			const isExpanded = burgerMenu.getAttribute("aria-expanded") === "true";
			burgerMenu.setAttribute("aria-expanded", String(!isExpanded));
			menuContainer.setAttribute("aria-hidden", String(isExpanded));

			document.querySelector('.ocw-top-bar')?.classList.toggle('is-active');
			document.querySelector('.ocw-navbar')?.classList.toggle('is-active');
			document.body.classList.toggle('scroll-lock');

			hideElementsWhenActive();

			if (document.querySelector('.ocw-top-bar')?.classList.contains("scroll-show")) {
				document.querySelector('.ocw-top-bar').classList.remove("scroll-show");
			}
		});

		// Keyboard support: close menu on Escape key
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape" && burgerMenu.getAttribute("aria-expanded") === "true") {
				// Trigger click to close the menu
				burgerMenu.click();
			}
		});
	}


	/* ============================================================
	   4. SUBMENU TOGGLING: SHARED HELPERS
	============================================================ */
	const dropdownItems = document.querySelectorAll(".menu-item-has-children");

	// Ensure each trigger knows which submenu it controls (aria-controls)
	dropdownItems.forEach((item, index) => {
		const trigger = item.querySelector("a");
		const submenuContainer = item.querySelector(".sub-menu-container");
		const submenu = submenuContainer?.querySelector(".sub-menu");

		if (!trigger || !submenu) return;

		let submenuId = submenu.id;
		if (!submenuId) {
			submenuId = `primary-submenu-${index}`;
			submenu.id = submenuId;
		}

		if (!trigger.hasAttribute("aria-controls")) {
			trigger.setAttribute("aria-controls", submenuId);
		}
		if (!trigger.hasAttribute("aria-haspopup")) {
			trigger.setAttribute("aria-haspopup", "true");
		}
		if (!trigger.hasAttribute("aria-expanded")) {
			trigger.setAttribute("aria-expanded", "false");
		}
	});

	const openSubmenu = (item) => {
		const submenu = item.querySelector(".sub-menu-container");
		const trigger = item.querySelector("a");

		if (!submenu || !trigger) return;

		item.classList.add("dropdown-show");

		trigger.setAttribute("aria-expanded", "true");
		submenu.setAttribute("aria-hidden", "false");
		setSubmenuFocusability(submenu, true);

		// mobile animated height (your original behavior preserved)
		if (isMobile()) {
			const dropdownContent = item.querySelector(".sub-menu");
			if (dropdownContent) {
				const dropdownHeight = dropdownContent.scrollHeight;
				const topBar = document.querySelector('.ocw-top-bar');
				const bottom = topBar ? topBar.getBoundingClientRect().bottom : 0;
				const dialogHeight = (window.innerHeight * 1.3 + dropdownHeight) - (bottom + 1);

				dropdownContent.style.height = `${dropdownHeight}px`;
				menuContainer.style.setProperty("--dialog-height", `${dialogHeight}px`);
			}
		}
	};

	const closeSubmenu = (item) => {
		const submenu = item.querySelector(".sub-menu-container");
		const trigger = item.querySelector("a");
		const dropdownContent = item.querySelector(".sub-menu");

		item.classList.remove("dropdown-show");

		if (trigger) trigger.setAttribute("aria-expanded", "false");
		if (submenu) {
			submenu.setAttribute("aria-hidden", "true");
			setSubmenuFocusability(submenu, false);
		}
		if (dropdownContent && isMobile()) dropdownContent.style.height = "";
	};

	// Small helper used by both click and keyboard
	const toggleSubmenu = (item) => {
		if (!item) return;
		const isOpen = item.classList.contains("dropdown-show");
		const openItem = document.querySelector(".dropdown-show");

		if (!isOpen) {
			if (openItem && openItem !== item) {
				closeSubmenu(openItem);
			}
			openSubmenu(item);
		} else {
			closeSubmenu(item);
		}
	};


	/* ============================================================
	   5. MOBILE CLICK HANDLER + KEYBOARD ACTIVATION
	============================================================ */
	dropdownItems.forEach((item) => {
		const trigger = item.querySelector("a");
		if (!trigger) return;

		// MOBILE: click/Enter behaves as a toggle (your original behavior)
		trigger.addEventListener("click", (e) => {
			if (!isMobile()) return; // desktop click still navigates

			e.preventDefault();
			toggleSubmenu(item);
		});

		// ALL VIEWPORTS: keyboard activation (Enter / Space)
		trigger.addEventListener("keydown", (e) => {
			const key = e.key || e.code;

			if (key === "Enter" || key === " ") {
				const isOpen = item.classList.contains("dropdown-show");

				if (!isOpen) {
					// First activation opens the submenu and prevents navigation
					e.preventDefault();
					toggleSubmenu(item);
				} else if (key === " ") {
					// Space when open toggles closed without navigation
					e.preventDefault();
					toggleSubmenu(item);
				}
			}
		});
	});


	/* ============================================================
	   6. DESKTOP HOVER / FOCUS BEHAVIOR
	============================================================ */
	if (!isMobile()) {
		dropdownItems.forEach((item) => {
			const trigger = item.querySelector("a");
			const submenu = item.querySelector(".sub-menu-container");
			if (!trigger || !submenu) return;

			// Keyboard/focus open
			trigger.addEventListener("focusin", () => {
				openSubmenu(item);
			});

			// Keyboard/focus close when leaving submenu
			item.addEventListener("focusout", (e) => {
				if (!item.contains(e.relatedTarget)) {
					closeSubmenu(item);
				}
			});
		});
	}


	/* ============================================================
	   7. WINDOW LOAD LOGIC 
	============================================================ */
	window.addEventListener("load", () => {
		get("prefs-hide-banner").then((val) => {
			if (val) {
				try {
					const data = JSON.parse(val);
					const oneDay = 1 * 60 * 60 * 1000;

					if (data.time && Date.now() - data.time < oneDay) {
						document.querySelector(".banner")?.remove();
						menuContainer.style.setProperty("--dialog-top", `auto`);
					}
				} catch (e) {
					console.error("Failed to parse prefs-hide-banner value:", err);
				}
			}
		});

		if (isMobile()) {
			dropdownItems.forEach((item) => item.classList.add("mobile"));
			refreshMobileHeighMenu();
			hideElementsWhenActive();
		}
	});


	/* ============================================================
	   8. RESIZE HANDLER
	============================================================ */
	window.addEventListener("resize", () => {
		closeAllSubmenus();

		if (isMobile()) {
			refreshMobileHeighMenu();
			hideElementsWhenActive();
		}
	});


	/* ============================================================
	   9. TOP BAR SCROLL BEHAVIOR 
	============================================================ */
	const handleScroll = () => {
		const doc = document.documentElement;
		const topBar = document.querySelector(".ocw-top-bar");
		if (!topBar) return;

		const { scrollHeight, clientHeight, scrollTop } = doc;
		const progress = (scrollTop / (scrollHeight - clientHeight)) * 100;

		const scrollingDown = scrollTop > position.y;
		position.y = Math.abs(scrollTop);

		const atTop = progress < 1;

		if (scrollingDown) {
			topBar.classList.remove("scroll-show");
		} else {
			topBar.classList.add("scroll-show");
			if (atTop) topBar.classList.remove("scroll-show");
		}
	};

	window.addEventListener("scroll", handleScroll, { passive: true });


	/* ============================================================
	   10. LANGUAGE TOGGLE 
	============================================================ */
	let url = window.location.href;
	const langToggles = document.querySelectorAll(".langselector a");

	if (url.endsWith("/news/")) {
		langToggles.forEach((el) => el.remove());
	} else {
		if (url.includes("/es/sucursales")) {
			url = url.replace("/es/sucursales", "/locations").replace("estado", "state").replace("ciudad", "city");
		} else if (url.includes("/locations")) {
			url = url.replace("/locations", "/es/sucursales").replace("state", "estado").replace("city", "ciudad");
		} else {
			url = "";
		}

		if (url !== "") {
			langToggles.forEach((el) => {
				el.href = url;
			});
		}
	}
}
